'use strict';

var device = require('./lib/device');

module.exports = function () {
  // Digits get dropped in samsung browser
  return !device.isSamsungBrowser();
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/restricted-input/supports-input-formatting.js
// module id = 202
// module chunks = 0